import React, { useState } from 'react';
import axios from 'axios';
import styles from './style.module.css';

import { faXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { receivingWaterBodyApi, waterSourceApi } from '../../../configs';
import { Button, InputField } from '../../elements';
import Swal from 'sweetalert2';

export default function WaterModal(props) {
  const { categoryId, siteId, setModalShow, fetchWaterData } = props;
  const [postLoading, setPostLoading] = useState(false);

  const handleSubmitWater = (e) => {
    e.preventDefault();

    const waterData =
      categoryId === 98
        ? {
            source_name: e.target.name.value,
            coordinate: e.target.coordinate.value,
          }
        : {
            body_name: e.target.name.value,
            coordinate: e.target.coordinate.value,
          };

    setPostLoading(true);

    // change water source API if already made
    const fetchApiused =
      categoryId === 98 ? waterSourceApi : receivingWaterBodyApi;

    axios
      .post(`${fetchApiused}/${siteId}`, waterData, {
        headers: {
          'Content-Type': 'application/json',
        },
      })
      .then((response) => {
        Swal.fire({
          title: 'Success!',
          text: response.data.msg,
          icon: 'success',
          confirmButtonColor: '#006CB7',
        });
        fetchWaterData();
        setPostLoading(false);
        setModalShow(false);
      })
      .catch((err) => {
        if (err.response) {
          console.log('err response', err.response);
          console.log('err response', err.response.message);
          Swal.fire({
            title: 'Failed to add the data!',
            text: err.response.message,
            icon: 'error',
            confirmButtonColor: '#006CB7',
          });
        }
        console.log('err', err);
        console.log('err message', err.message);
        Swal.fire({
          title: 'Failed to add the data!',
          text: err.message,
          icon: 'error',
          confirmButtonColor: '#006CB7',
        });

        setPostLoading(false);
      });
  };

  return (
    <div className={styles.root}>
      <div className={styles.modalWrapper}>
        <div className={styles.modalHeader}>
          <h2>
            {categoryId === 98 ? 'Tambah Sumber Air' : 'Tambah Badan Air'}
          </h2>
          <FontAwesomeIcon
            icon={faXmark}
            className={styles.closeIcon}
            onClick={() => !postLoading && setModalShow(false)}
          />
        </div>
        <div className={styles.modalContent}>
          <form onSubmit={handleSubmitWater}>
            <InputField
              name="name"
              type="text"
              label="Nama"
              className={styles.input}
              pattern="[a-zA-Z0-9\s]+"
            />
            <InputField
              name="coordinate"
              type="text"
              label="Kordinat"
              className={styles.input}
              // pattern={`[^<>_:;?/"][)('+=*&^@!$%#]+`}
            />

            <Button label="Tambah" color="primary" disabled={postLoading} />
          </form>
        </div>
      </div>
    </div>
  );
}
